import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { PayloadStates } from '@lore/utils';
import Loader from '../../../components/Loader';
import useProjectTags from '../../../hooks/useProjectTags';
import TagTypes from '../../../constants/TagTypes';
import useTags from '../../../hooks/useTags';
import TextContentSection from '../../../components_profiles/TextContentSection';

Skills.propTypes = {
  project: PropTypes.object.isRequired
};

export default function Skills(props) {
  const { project } = props;

  const projectExpertiseTypes = useProjectTags(project, TagTypes.ExpertiseType);

  if (projectExpertiseTypes.state === PayloadStates.FETCHING) {
    return (
      <Loader />
    );
  }

  if (projectExpertiseTypes.data.length === 0) {
    return null;
  }

  return (
    <TextContentSection title="Desired skill areas">
      <ul className="list-disc ml-6">
        {projectExpertiseTypes.data.map(function(tag) {
          return (
            <li key={tag.id || tag.cid}>
              {tag.data.name}
            </li>
          );
        })}
      </ul>
    </TextContentSection>
  );
};
